import React, { Children } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeftIcon } from 'lucide-react';
import { Footer } from '../components/Footer';
export function PrivacyPolicy() {
  return <div className="w-full min-h-screen bg-slate-50" data-id="element-85">
      <div className="max-w-4xl mx-auto px-6 py-12" data-id="element-86">
        <Link to="/" className="inline-flex items-center gap-2 text-blue-600 hover:text-blue-700 mb-8 font-medium" data-id="element-87">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-88" />
          Back to Home
        </Link>
        <div className="bg-white rounded-2xl shadow-sm p-8 md:p-12" data-id="element-89">
          <h1 className="text-4xl md:text-5xl font-bold text-slate-900 mb-8" data-id="element-90">
            Privacy Policy
          </h1>
          <div className="prose prose-slate max-w-none space-y-8" data-id="element-91">
            <section data-id="element-92">
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-93">
                Last updated:{' '}
                {new Date().toLocaleDateString('en-GB', {
                day: 'numeric',
                month: 'long',
                year: 'numeric'
              })}
              </p>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-94">
                Pomelo Services Ltd ("us", "we", "our") is a limited liability
                company registered in England and Wales, number 13810984. Our
                registered office address is Kemp House, 160 City Road, London,
                United Kingdom.
              </p>
              <p className="text-slate-700 leading-relaxed" data-id="element-95">
                This Privacy Policy describes how we collect, use, and protect
                your personal information when you use our Enhanced Payment
                Protection services and visit our website.
              </p>
            </section>
            <section data-id="element-96">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-97">
                1. Information We Collect
              </h2>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-98">
                1.1 Information You Provide
              </h3>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-99">
                When you use our services, we may collect the following
                information:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-100">
                <li data-id="element-101">
                  Personal identification information (name, email address,
                  phone number)
                </li>
                <li data-id="element-102">
                  Payment card information (card number, expiry date, CVV)
                </li>
                <li data-id="element-103">Billing address and other contact details</li>
                <li data-id="element-104">Transaction history and payment details</li>
                <li data-id="element-105">Communication preferences</li>
              </ul>
              <h3 className="text-xl font-semibold text-slate-900 mb-3" data-id="element-106">
                1.2 Information We Collect Automatically
              </h3>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-107">
                When you access our services, we automatically collect:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-108">
                <li data-id="element-109">
                  Device information (IP address, browser type, operating
                  system)
                </li>
                <li data-id="element-110">Usage data (pages visited, time spent, features used)</li>
                <li data-id="element-111">Cookies and similar tracking technologies</li>
                <li data-id="element-112">Location data (with your consent)</li>
              </ul>
            </section>
            <section data-id="element-113">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-114">
                2. How We Use Your Information
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-115">
                We use your personal information for the following purposes:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-116">
                <li data-id="element-117">To process and facilitate your payment transactions</li>
                <li data-id="element-118">
                  To provide and maintain our Enhanced Payment Protection
                  services
                </li>
                <li data-id="element-119">To verify your identity and prevent fraud</li>
                <li data-id="element-120">To comply with legal and regulatory obligations</li>
                <li data-id="element-121">
                  To communicate with you about your transactions and our
                  services
                </li>
                <li data-id="element-122">To improve our services and develop new features</li>
                <li data-id="element-123">
                  To send you marketing communications (with your consent)
                </li>
                <li data-id="element-124">
                  To respond to your inquiries and provide customer support
                </li>
                <li data-id="element-125">
                  To detect, prevent, and address technical issues and security
                  threats
                </li>
              </ul>
            </section>
            <section data-id="element-126">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-127">
                3. Legal Basis for Processing
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-128">
                We process your personal data under the following legal bases:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-129">
                <li data-id="element-130">
                  <strong data-id="element-131">Contract Performance:</strong> Processing necessary to
                  fulfill our contractual obligations to you
                </li>
                <li data-id="element-132">
                  <strong data-id="element-133">Legal Obligation:</strong> Processing required to
                  comply with legal and regulatory requirements
                </li>
                <li data-id="element-134">
                  <strong data-id="element-135">Legitimate Interests:</strong> Processing necessary
                  for our legitimate business interests, such as fraud
                  prevention and service improvement
                </li>
                <li data-id="element-136">
                  <strong data-id="element-137">Consent:</strong> Processing based on your explicit
                  consent, which you may withdraw at any time
                </li>
              </ul>
            </section>
            <section data-id="element-138">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-139">
                4. How We Share Your Information
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-140">
                We may share your information with:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-141">
                <li data-id="element-142">
                  <strong data-id="element-143">Payment Service Providers:</strong> To process your
                  transactions securely
                </li>
                <li data-id="element-144">
                  <strong data-id="element-145">Merchants:</strong> Limited information necessary to
                  complete your purchase
                </li>
                <li data-id="element-146">
                  <strong data-id="element-147">Service Providers:</strong> Third parties who assist
                  us in operating our services
                </li>
                <li data-id="element-148">
                  <strong data-id="element-149">Regulatory Authorities:</strong> When required by law
                  or to comply with legal obligations
                </li>
                <li data-id="element-150">
                  <strong data-id="element-151">Law Enforcement:</strong> When necessary to protect
                  our rights or comply with legal processes
                </li>
                <li data-id="element-152">
                  <strong data-id="element-153">Business Transfers:</strong> In connection with a
                  merger, acquisition, or sale of assets
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-154">
                We do not sell your personal information to third parties.
              </p>
            </section>
            <section data-id="element-155">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-156">
                5. Data Security
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-157">
                We implement robust security measures to protect your personal
                information:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-158">
                <li data-id="element-159">PCI DSS Level 1 compliance for payment data</li>
                <li data-id="element-160">
                  Industry-standard encryption (TLS/SSL) for data transmission
                </li>
                <li data-id="element-161">Secure storage with encryption at rest</li>
                <li data-id="element-162">Regular security audits and vulnerability assessments</li>
                <li data-id="element-163">Access controls and authentication measures</li>
                <li data-id="element-164">Employee training on data protection and security</li>
                <li data-id="element-165">3D Secure authentication for eligible transactions</li>
                <li data-id="element-166">
                  Single-use virtual cards to protect your payment details
                </li>
              </ul>
            </section>
            <section data-id="element-167">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-168">
                6. Data Retention
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-169">
                We retain your personal information for as long as necessary to:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-170">
                <li data-id="element-171">Provide our services to you</li>
                <li data-id="element-172">Comply with legal and regulatory obligations</li>
                <li data-id="element-173">Resolve disputes and enforce our agreements</li>
                <li data-id="element-174">Maintain business records for legitimate purposes</li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-175">
                Transaction data is typically retained for a minimum of 7 years
                to comply with financial regulations. Once the retention period
                expires, we securely delete or anonymize your data.
              </p>
            </section>
            <section data-id="element-176">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-177">
                7. Your Rights
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-178">
                Under data protection laws, you have the following rights:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-179">
                <li data-id="element-180">
                  <strong data-id="element-181">Right of Access:</strong> Request a copy of the
                  personal data we hold about you
                </li>
                <li data-id="element-182">
                  <strong data-id="element-183">Right to Rectification:</strong> Request correction of
                  inaccurate or incomplete data
                </li>
                <li data-id="element-184">
                  <strong data-id="element-185">Right to Erasure:</strong> Request deletion of your
                  personal data (subject to legal obligations)
                </li>
                <li data-id="element-186">
                  <strong data-id="element-187">Right to Restriction:</strong> Request limitation on
                  how we process your data
                </li>
                <li data-id="element-188">
                  <strong data-id="element-189">Right to Data Portability:</strong> Receive your data
                  in a structured, machine-readable format
                </li>
                <li data-id="element-190">
                  <strong data-id="element-191">Right to Object:</strong> Object to processing based
                  on legitimate interests
                </li>
                <li data-id="element-192">
                  <strong data-id="element-193">Right to Withdraw Consent:</strong> Withdraw consent
                  for processing at any time
                </li>
                <li data-id="element-194">
                  <strong data-id="element-195">Right to Lodge a Complaint:</strong> Contact the
                  Information Commissioner's Office (ICO)
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-196">
                To exercise any of these rights, please contact us at{' '}
                <a href="mailto:info@pomeloservices.uk" className="text-blue-600 hover:text-blue-700" data-id="element-197">
                  info@pomeloservices.uk
                </a>
              </p>
            </section>
            <section data-id="element-198">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-199">
                8. Cookies and Tracking Technologies
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-200">
                We use cookies and similar technologies to:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-201">
                <li data-id="element-202">Maintain your session and preferences</li>
                <li data-id="element-203">Analyze website usage and performance</li>
                <li data-id="element-204">Provide personalized content and advertising</li>
                <li data-id="element-205">Detect and prevent fraud</li>
              </ul>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-206">
                You can control cookies through your browser settings. However,
                disabling cookies may affect the functionality of our services.
              </p>
            </section>
            <section data-id="element-207">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-208">
                9. International Data Transfers
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-209">
                Your information may be transferred to and processed in
                countries outside the United Kingdom. When we transfer data
                internationally, we ensure appropriate safeguards are in place,
                including:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2" data-id="element-210">
                <li data-id="element-211">
                  Standard contractual clauses approved by the European
                  Commission
                </li>
                <li data-id="element-212">
                  Adequacy decisions recognizing equivalent data protection
                  standards
                </li>
                <li data-id="element-213">Other lawful transfer mechanisms under UK GDPR</li>
              </ul>
            </section>
            <section data-id="element-214">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-215">
                10. Children's Privacy
              </h2>
              <p className="text-slate-700 leading-relaxed" data-id="element-216">
                Our services are not intended for individuals under the age of
                18. We do not knowingly collect personal information from
                children. If you believe we have inadvertently collected
                information from a child, please contact us immediately.
              </p>
            </section>
            <section data-id="element-217">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-218">
                11. Changes to This Privacy Policy
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-219">
                We may update this Privacy Policy from time to time to reflect
                changes in our practices or legal requirements. We will notify
                you of any material changes by:
              </p>
              <ul className="list-disc pl-6 text-slate-700 space-y-2 mb-4" data-id="element-220">
                <li data-id="element-221">Posting the updated policy on our website</li>
                <li data-id="element-222">
                  Updating the "Last updated" date at the top of this policy
                </li>
                <li data-id="element-223">
                  Sending you an email notification (for significant changes)
                </li>
              </ul>
              <p className="text-slate-700 leading-relaxed" data-id="element-224">
                We encourage you to review this Privacy Policy periodically to
                stay informed about how we protect your information.
              </p>
            </section>
            <section data-id="element-225">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-226">
                12. Contact Us
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-227">
                If you have any questions, concerns, or requests regarding this
                Privacy Policy or our data practices, please contact us:
              </p>
              <div className="bg-slate-50 rounded-lg p-6 space-y-2 text-slate-700" data-id="element-228">
                <p data-id="element-229">
                  <strong data-id="element-230">Pomelo Services Ltd</strong>
                </p>
                <p data-id="element-231">Kemp House, 160 City Road</p>
                <p data-id="element-232">London, United Kingdom</p>
                <p data-id="element-233">EC1V 2NX</p>
                <p className="pt-2" data-id="element-234">
                  Email:{' '}
                  <a href="mailto:info@pomeloservices.uk" className="text-blue-600 hover:text-blue-700" data-id="element-235">
                    info@pomeloservices.uk
                  </a>
                </p>
                <p data-id="element-236">
                  Support:{' '}
                  <a href="mailto:enquiries@pomeloservices.uk" className="text-blue-600 hover:text-blue-700" data-id="element-237">
                    enquiries@pomeloservices.uk
                  </a>
                </p>
              </div>
            </section>
            <section data-id="element-238">
              <h2 className="text-2xl font-bold text-slate-900 mb-4" data-id="element-239">
                13. Supervisory Authority
              </h2>
              <p className="text-slate-700 leading-relaxed mb-4" data-id="element-240">
                If you have concerns about how we handle your personal data, you
                have the right to lodge a complaint with the UK's supervisory
                authority:
              </p>
              <div className="bg-slate-50 rounded-lg p-6 space-y-2 text-slate-700" data-id="element-241">
                <p data-id="element-242">
                  <strong data-id="element-243">Information Commissioner's Office (ICO)</strong>
                </p>
                <p data-id="element-244">Wycliffe House, Water Lane</p>
                <p data-id="element-245">Wilmslow, Cheshire</p>
                <p data-id="element-246">SK9 5AF</p>
                <p className="pt-2" data-id="element-247">
                  Website:{' '}
                  <a href="https://ico.org.uk" className="text-blue-600 hover:text-blue-700" data-id="element-248">
                    https://ico.org.uk
                  </a>
                </p>
                <p data-id="element-249">Helpline: 0303 123 1113</p>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Footer data-id="element-250" />
    </div>;
}